<template>
    <el-dialog
            :title="title"
            :visible.sync="showFlag"
            width="30%"
            append-to-body
            @close="closeDialog"
    >
        <div class="icon-box">
            <ul>
                <li v-for="(item, i) in iconList" @click="selectIcon(i)"><i class="iconfont" :class="item.class"></i></li>
            </ul>
        </div>
    </el-dialog>
</template>
<script>
    export default {
        name: 'iconDialog',
        data() {
            return {
                title: '选择图标',
                showFlag: false,
                iconList: [],
                menu: {}
            }
        },
        methods: {
            show(menu) {
                this.menu = menu;
                this.showFlag = true;
                this.loadIconList();
            },
            loadIconList() {
                this.$store.dispatch('system/menuItem/loadIconList',{}).then((res) => {
                   this.iconList = res;
                });
            },
            selectIcon(i) {
                this.menu.menuIcon = this.iconList[i].class;
                this.closeDialog();
            },
            closeDialog() {
                this.showFlag = false;
            }
        }
    }
</script>
<style scoped>
    .icon-box {
        height: 500px;
        width: 511px;
        margin: 0 auto;
        overflow-y: scroll;
        margin-bottom: 5px;
    }
    .icon-box ul {
        display: block;
        margin-block-start: 1em;
        margin-block-end: 1em;
        margin-inline-start: 0;
        margin-inline-end: 0;
        padding-inline-start: 40px;
        overflow: hidden;
        list-style: none;
        padding: 0!important;
        border: 1px solid #eaeefb;
        border-radius: 4px;

    }
    .icon-box li {
        float: left;
        width: 50px;
        text-align: center;
        line-height: 50px;
        color: #666;
        font-size: 13px;
        border-right: 1px solid #eee;
        border-bottom: 1px solid #eee;
        margin-right: -1px;
        margin-bottom: -1px;
        cursor: pointer;
    }
    .icon-box li:hover {
        color: #5ED1FD;
    }
    .icon-box li i {
        font-size: 25px;
    }
</style>